/**
 * Unica fonte CSS per i termini contrattuali (.content-block).
 * - PDF: getTermsContentBlockCss() senza scope (selettori .content-block …)
 * - Anteprima: getTermsContentBlockCss('.preventivo-terms-pdf-style') per isolare dal resto dell’app
 */

export function getTermsContentBlockCss(scopeSelector = '') {
  const p = scopeSelector ? `${scopeSelector} ` : '';

  return `
${p}.content-block {
  margin: 35px 0;
  text-align: justify;
  page-break-inside: avoid;
  font-family: 'Inter', sans-serif;
  font-size: 10pt;
  line-height: 1.7;
  color: #111;
}

${p}.content-block h2 {
  font-family: 'Playfair Display', serif;
  font-size: 12pt;
  font-weight: 700;
  margin-top: 25px;
  margin-bottom: 12px;
  text-transform: uppercase;
  page-break-after: avoid;
  page-break-inside: avoid;
}

${p}.content-block h3 {
  font-family: 'Playfair Display', serif;
  font-size: 10.5pt;
  font-weight: 600;
  margin-top: 18px;
  margin-bottom: 8px;
  page-break-after: avoid;
}

${p}.content-block p {
  margin-bottom: 12px;
  line-height: 1.7;
  text-align: justify;
  orphans: 3;
  widows: 3;
}

${p}.content-block ul {
  margin-left: 20px;
  margin-bottom: 12px;
  page-break-inside: avoid;
}

${p}.content-block li {
  margin-bottom: 6px;
  line-height: 1.6;
}

${p}.content-block ol {
  margin-left: 20px;
  margin-bottom: 12px;
  page-break-inside: avoid;
}

${p}.content-block blockquote {
  margin: 12px 0 12px 16px;
  padding-left: 12px;
  border-left: 2px solid #ccc;
  font-style: italic;
  color: #444;
}

${p}.content-block a {
  color: #111;
  text-decoration: underline;
}

${p}.content-block strong { font-weight: 600; }
${p}.content-block em { font-style: italic; }

${p}.content-block div {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

${p}.content-block table {
  width: 100%;
  border-collapse: collapse;
  page-break-inside: avoid;
  margin: 15px 0;
}

${p}.content-block th {
  text-align: left;
  font-family: 'Playfair Display', serif;
  font-size: 9pt;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1.5px solid #000;
  padding: 8px 0;
  color: #111;
}

${p}.content-block td {
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  vertical-align: top;
  font-size: 9.5pt;
}
`.trim();
}

/** Per l’anteprima React: font + stessi selettori scoped */
export function getTermsContentBlockPreviewStyleTagInner(scopeClass = '.preventivo-terms-pdf-style') {
  return (
    "@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Inter:wght@300;400;500&display=swap');\n" +
    getTermsContentBlockCss(scopeClass)
  );
}
